import {CustomerSearchType} from './helpers/enums';

export interface ISearchUserReq {
  type: CustomerSearchType,
  value: string
}

export interface IImpersonateReq {
  impersonateReq: {
    accountId: string
  }
}

export interface UserRole {
  name: string;
}

export interface User {
  readonly Id?: number;
  FirstName: string;
  LastName: string;
  UserName: string;
  Password: string;
  EmailAddress: string;
  Version: string;
  Profession: string;
  IsB2O: boolean;
  IsMasterAdmin: boolean;
  UserRoles: UserRole[];
}

export interface Bill {
  readonly Id?: number;
  DataEmissione: string;
  DataScadenza: string;
  Importo: string;
  IsSaldata: boolean;
  NumeroFattura: string;
  TipoStampa: string;
}

export interface UnpaidBill extends Bill {
  Dilazione: string;
  ImportoSaldato: string;
}

export interface Meter {
  Diametro: string;
  Matricola: string;
  NumeroIndici: number;
  Ubicazione: string;
}

export interface MeterReading {
  NumeroFattura: string;
  DataInizio: string;
  DataFine: string;
  Consumo: string;
  LetturaAttuale: number;
  LetturaPrecedente: number;
  Matricola: string;
  StatoLettura: string;
}

export interface BillingAddress {
  street: string,
  streetNumber: string,
  postalCode: string,
  city: string,
  province: string,
  region: string,
  country: string
}

export interface LegalAddress {
  street: string,
  streetNumber: string,
  postalCode: string,
  city: string,
  province: string,
  region: string,
  country: string
}

export interface HeadOfficeAddress {
  street: string,
  streetNumber: string,
  postalCode: string,
  city: string,
  province: string,
  region: string,
  country: string
}

export interface Profile {
  name: string;
  surname: string;
  role: string;
  email: string;
  pec: string;
  isLegacy:boolean;
  mobilePhoneNumber: string;
  landlinePhoneNumber: string;
  fiscalCode: string;
  agreementProfiling: string;
  agreementMarketing: string;
  businessName: string;
  BillingAddress: BillingAddress,
  LegalAddress: LegalAddress,
  HeadOfficeAddress: HeadOfficeAddress
}

export const searchUserReq = (value: string, type: string) => {

  return {
    type: type,
    value: value
  }
}

export const listContractsReq = (recordsPerPage: number, page: number) => {
  return {
    recordsPerPage: recordsPerPage,
    page: page
  }
}


export const ImpersonateReq = (safoAccountId: string) => {
  return {
    impersonateReq: {
      accountId: safoAccountId
    }
  } as IImpersonateReq
}
